// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quantity-buttons[data-v-a2acc130]{white-space:nowrap}.quantity-buttons .quantity-adjustment[data-v-a2acc130]{font-size:3rem}", ""]);
// Exports
module.exports = exports;
